import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredDiamondGreen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#clip0_7560_29756)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.22927 1.06778C3.30578 0.947402 3.43459 0.875095 3.57252 0.875095H10.4275C10.5654 0.875095 10.6942 0.947402 10.7707 1.06778L13.0557 4.66288C13.1538 4.81714 13.1472 5.01978 13.0394 5.16674L7.32699 12.9561C7.2489 13.0626 7.12808 13.125 7 13.125C6.87192 13.125 6.7511 13.0626 6.67301 12.9561L0.960552 5.16674C0.85278 5.01978 0.846239 4.81714 0.944287 4.66288L3.22927 1.06778ZM3.79331 1.74053L1.7948 4.88489L7 11.9826L12.2052 4.88489L10.2067 1.74053H3.79331Z"
        fill="url(#paint0_linear_7560_29756)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.61325 0.920778C6.81703 1.02765 6.89963 1.28757 6.79774 1.50133L5.38252 4.47019H8.61748L7.20226 1.50133C7.10037 1.28757 7.18297 1.02765 7.38675 0.920778C7.59054 0.813902 7.83834 0.900542 7.94023 1.11429L9.53995 4.47019H12.7125C12.9403 4.47019 13.125 4.66393 13.125 4.90291C13.125 5.14189 12.9403 5.33562 12.7125 5.33562H9.58968L7.39611 12.8134C7.39272 12.8255 7.38883 12.8375 7.38446 12.8493C7.36321 12.9067 7.33126 12.957 7.29179 12.9983C7.25237 13.0397 7.20443 13.0732 7.14965 13.0955C7.10251 13.1148 7.05182 13.125 7 13.125C6.94818 13.125 6.89749 13.1148 6.85035 13.0955C6.79557 13.0732 6.74763 13.0397 6.70822 12.9983C6.66874 12.957 6.63679 12.9067 6.61554 12.8492C6.61117 12.8375 6.60728 12.8255 6.60389 12.8134L4.41032 5.33562H1.28754C1.0597 5.33562 0.875001 5.14189 0.875001 4.90291C0.875001 4.66393 1.0597 4.47019 1.28754 4.47019H4.46005L6.05977 1.11429C6.16166 0.900542 6.40946 0.813902 6.61325 0.920778ZM5.27358 5.33562L7 11.2209L8.72642 5.33562H5.27358Z"
        fill="url(#paint1_linear_7560_29756)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_7560_29756"
        x1={0.875}
        y1={0.875}
        x2={13.125}
        y2={0.875}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007A1B" />
        <stop offset={1} stopColor="#6AE723" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7560_29756"
        x1={0.875}
        y1={0.875}
        x2={13.125}
        y2={0.875}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007A1B" />
        <stop offset={1} stopColor="#6AE723" />
      </linearGradient>
      <clipPath id="clip0_7560_29756">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredDiamondGreen)
const IconSvgColouredDiamondGreen = createIcon(
  ForwardRef,
  'SvgColouredDiamondGreen',
)
export default IconSvgColouredDiamondGreen
